import React, { useState, useEffect } from 'react';
import { ContentBox } from '../ContentBox';

export function DepartmentPositionList({ id, positionList }) {
    const [mPositionList, setPositionList] = useState([])

    useEffect(()=>{
        if(positionList !== undefined && positionList !== mPositionList){
            setPositionList(positionList)
        }
    },[positionList])

    function toAdd() {
        window.location.assign("/DepartmentPositionAdd/"+id);
    }

    var title = '職稱列表'
    var title_tools =
        <a className="dropdown-toggle " onClick={e => toAdd()} data-toggle="dropdown" href="#A">
            <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">新增</span>
        </a>
    var content =
        <>
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-4">職稱</th>
                                    <th className="text-center sorting col-sm-4">級別</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    mPositionList.map((position) => (
                                        <PositionBox key={position.roleId} position={position} />
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    return (
        <>
        <ContentBox title={title} title_tools={title_tools} content={content} hasDrawer={false} />
        </>
    )
}


function PositionBox({ position }) {
    const [mPosition, setPosition] = useState({})
    const [roleId, setRoleId] = useState("")
    const [roleName, setRoleName] = useState("")
    const [isSupervisor, setIsSupervisor] = useState(0)

    useEffect(() => {
        if (position !== undefined && position !== mPosition) {
            //console.log(department)
            setPosition(position)
            setRoleId(position.roleId)
            setRoleName(position.roleName)
            setIsSupervisor(position.isSupervisor)
        }
    }, [position])

    function toResumeEdit() {
        window.location.assign("/DepartmentPositionEdit/" + roleId);
    }

    return (
        <tr role="row">
            <td className="text-center"><a href="#A" onClick={e => toResumeEdit()}>{roleName}</a>&nbsp;</td>
            <td className="text-center">
                {isSupervisor === "" ? <></> : isSupervisor===0 ? "員工" : "主管"}
            </td>
        </tr>
    )
}
